export enum EFormShipFromValue {
  customer,
  buki,
}
